export default __webpack_public_path__ + "static/media/access_denied.0b448020.svg";